
export interface AirportStorage {
  total: number,
  used: number
}

export enum CoverStateEnum {
  Close = 0,
  Open = 1,
  HalfOpen = 2,
  Failed = 3
}

export enum PutterStateEnum {
  Close = 0,
  Open = 1,
  HalfOpen = 2,
  Failed = 3
}

export enum ChargeStateEnum {
  NotCharge = 0,
  Charge = 1,
}

export interface DroneChargeState {
  state: ChargeStateEnum,
  capacity_percent: string,
}

export enum SupplementLightStateEnum {
  Close = 0,
  Open = 1,
}

export enum AlarmModeEnum {
  CLOSE = 0,
  OPEN = 1,
}

export enum BatteryStoreModeEnum {
  BATTERY_PLAN_STORE = 1,
  BATTERY_EMERGENCY_STORE = 2,
}

export enum DroneBatteryStateEnum {
  NoMaintenanceRequired = 0,
  MaintenanceRequired = 1,
  MaintenanceInProgress = 2,
}

export enum DroneBatteryModeEnum {
  CLOSE = 0,
  OPEN = 1,
}

export enum FourGLinkStateEnum {
  CLOSE = 0,
  OPEN = 1,
}

export enum SdrLinkStateEnum {
  CLOSE = 0,
  OPEN = 1,
}

export enum LinkWorkModeEnum {
  SDR = 0,
  FourG_FUSION_MODE = 1,
}
